import type { I18nContextValue } from "../i18n/useI18n";

const AUTO_CHECKOUT_TIMEOUT_MESSAGES = new Set([
  "Automatisch ausgecheckt (Timeout)",
  "automatisch ausgecheckt (Timeout)"
]);

export function formatCheckInEventMessage(
  message: string | null | undefined,
  text: I18nContextValue["text"]
): string {
  const normalized = (message ?? "").trim();
  if (!normalized) return text("—");
  if (AUTO_CHECKOUT_TIMEOUT_MESSAGES.has(normalized)) return text("Automatically checked out");
  if (normalized.startsWith("E_Aggregator")) return text(normalized);
  return normalized;
}
